import React from 'react';
import { Outlet } from 'react-router-dom';

export default function ElectronicInvoicing() {
  return (
    <div className="flex h-full flex-col" data-dd-privacy="allow">
      <Outlet />
    </div>
  );
}
